export const VOCAB = [
  { id:1,  word:"سلام",       translation:"hello" },
  { id:2,  word:"خداحافظ",   translation:"goodbye" },
  { id:3,  word:"ممنون",      translation:"thank you" },
  { id:4,  word:"لطفاً",      translation:"please" },
  { id:5,  word:"بله",        translation:"yes" },
  { id:6,  word:"نه",         translation:"no" },
  { id:7,  word:"آب",         translation:"water" },
  { id:8,  word:"غذا",        translation:"food" },
  { id:9,  word:"خانه",       translation:"house" },
  { id:10, word:"مدرسه",      translation:"school" },
  { id:11, word:"کتاب",       translation:"book" },
  { id:12, word:"قلم",        translation:"pen" },
  { id:13, word:"میز",        translation:"table" },
  { id:14, word:"صندلی",      translation:"chair" },
  { id:15, word:"در",         translation:"door" },
  { id:16, word:"پنجره",      translation:"window" },
  { id:17, word:"آفتاب",      translation:"sun" },
  { id:18, word:"ماه",        translation:"moon" },
  { id:19, word:"ستاره",      translation:"star" },
  { id:20, word:"درخت",       translation:"tree" },
  { id:21, word:"گربه",       translation:"cat" },
  { id:22, word:"سگ",         translation:"dog" },
  { id:23, word:"مادر",       translation:"mother" },
  { id:24, word:"پدر",        translation:"father" },
  { id:25, word:"برادر",      translation:"brother" },
  { id:26, word:"خواهر",      translation:"sister" },
  { id:27, word:"مرد",        translation:"man" },
  { id:28, word:"زن",         translation:"woman" },
  { id:29, word:"پسر",        translation:"boy/son" },
  { id:30, word:"دختر",       translation:"girl/daughter" },
  { id:31, word:"نان",        translation:"bread" },
  { id:32, word:"شیر",        translation:"milk" },
  { id:33, word:"چای",        translation:"tea" },
  { id:34, word:"قهوه",       translation:"coffee" },
  { id:35, word:"قرمز",       translation:"red" },
  { id:36, word:"آبی",        translation:"blue" },
  { id:37, word:"سبز",        translation:"green" },
  { id:38, word:"زرد",        translation:"yellow" },
  { id:39, word:"سفید",       translation:"white" },
  { id:40, word:"سیاه",       translation:"black" },
  { id:41, word:"یک",         translation:"one" },
  { id:42, word:"دو",         translation:"two" },
  { id:43, word:"سه",         translation:"three" },
  { id:44, word:"چهار",       translation:"four" },
  { id:45, word:"پنج",        translation:"five" },
  { id:46, word:"شش",         translation:"six" },
  { id:47, word:"هفت",        translation:"seven" },
  { id:48, word:"هشت",        translation:"eight" },
  { id:49, word:"نه",         translation:"nine" },
  { id:50, word:"ده",         translation:"ten" },
  { id:51, word:"بزرگ",       translation:"big" },
  { id:52, word:"کوچک",       translation:"small" },
  { id:53, word:"خوب",        translation:"good" },
  { id:54, word:"بد",         translation:"bad" },
  { id:55, word:"گرم",        translation:"hot/warm" },
  { id:56, word:"سرد",        translation:"cold" },
  { id:57, word:"سریع",       translation:"fast" },
  { id:58, word:"آهسته",      translation:"slow" },
  { id:59, word:"صبح",        translation:"morning" },
  { id:60, word:"شب",         translation:"night" },
  { id:61, word:"امروز",      translation:"today" },
  { id:62, word:"فردا",       translation:"tomorrow" },
  { id:63, word:"دیروز",      translation:"yesterday" },
  { id:64, word:"دوست",       translation:"friend" },
  { id:65, word:"معلم",       translation:"teacher" },
  { id:66, word:"پزشک",       translation:"doctor" },
  { id:67, word:"شهر",        translation:"city" },
  { id:68, word:"خیابان",     translation:"street" },
  { id:69, word:"بازار",      translation:"market" },
  { id:70, word:"هتل",        translation:"hotel" },
  { id:71, word:"رستوران",    translation:"restaurant" },
  { id:72, word:"برنج",       translation:"rice" },
  { id:73, word:"گوشت",       translation:"meat" },
  { id:74, word:"میوه",       translation:"fruit" },
  { id:75, word:"ماشین",      translation:"car" },
  { id:76, word:"تلفن",       translation:"telephone" },
  { id:77, word:"پول",        translation:"money" },
  { id:78, word:"زیبا",       translation:"beautiful" },
  { id:79, word:"جدید",       translation:"new" },
  { id:80, word:"قدیمی",      translation:"old" },
  { id:81,  word:"رفتن",        translation:"to go" },
  { id:82,  word:"آمدن",        translation:"to come" },
  { id:83,  word:"خوردن",       translation:"to eat" },
  { id:84,  word:"خوابیدن",     translation:"to sleep" },
  { id:85,  word:"نوشتن",       translation:"to write" },
  { id:86,  word:"خواندن",      translation:"to read" },
  { id:87,  word:"دیدن",        translation:"to see" },
  { id:88,  word:"شنیدن",       translation:"to hear" },
  { id:89,  word:"گفتن",        translation:"to say" },
  { id:90,  word:"دانستن",      translation:"to know" },
  { id:91,  word:"فکر کردن",    translation:"to think" },
  { id:92,  word:"کار کردن",    translation:"to work" },
  { id:93,  word:"بازی کردن",   translation:"to play" },
  { id:94,  word:"یاد گرفتن",   translation:"to learn" },
  { id:95,  word:"دویدن",       translation:"to run" },
  { id:96,  word:"نشستن",       translation:"to sit" },
  { id:97,  word:"ایستادن",     translation:"to stand" },
  { id:98,  word:"آشامیدن",     translation:"to drink" },
  { id:99,  word:"دوست داشتن",  translation:"to like/love" },
  { id:100, word:"پرسیدن",      translation:"to ask" },
  { id:101, word:"هواپیما",     translation:"airplane" },
  { id:102, word:"اتوبوس",      translation:"bus" },
  { id:103, word:"قطار",        translation:"train" },
  { id:104, word:"دوچرخه",      translation:"bicycle" },
  { id:105, word:"بیمارستان",   translation:"hospital" },
  { id:106, word:"داروخانه",    translation:"pharmacy" },
  { id:107, word:"فرودگاه",     translation:"airport" },
  { id:108, word:"ایستگاه",     translation:"station" },
  { id:109, word:"بانک",        translation:"bank" },
  { id:110, word:"زبان",        translation:"language" },
  { id:111, word:"فارسی",       translation:"Persian/Farsi" },
  { id:112, word:"انگلیسی",     translation:"English" },
  { id:113, word:"دریا",        translation:"sea" },
  { id:114, word:"کوه",         translation:"mountain" },
  { id:115, word:"جنگل",        translation:"forest" },
  { id:116, word:"بیابان",      translation:"desert" },
  { id:117, word:"رودخانه",     translation:"river" },
  { id:118, word:"آسمان",       translation:"sky" },
  { id:119, word:"باران",       translation:"rain" },
  { id:120, word:"برف",         translation:"snow" },
  { id:121, word:"نارنجی",      translation:"orange" },
  { id:122, word:"بنفش",        translation:"purple" },
  { id:123, word:"قهوه‌ای",     translation:"brown" },
  { id:124, word:"صورتی",       translation:"pink" },
  { id:125, word:"هفته",        translation:"week" },
  { id:126, word:"سال",         translation:"year" },
  { id:127, word:"تاریخ",       translation:"history/date" },
  { id:128, word:"ورزش",        translation:"sport/exercise" },
  { id:129, word:"فوتبال",      translation:"football/soccer" },
  { id:130, word:"موسیقی",      translation:"music" },
  { id:131, word:"سینما",       translation:"cinema" },
  { id:132, word:"نقاشی",       translation:"painting" },
  { id:133, word:"رایانه",      translation:"computer" },
  { id:134, word:"اینترنت",     translation:"internet" },
  { id:135, word:"تلویزیون",    translation:"television" },
  { id:136, word:"خرید",        translation:"shopping" },
  { id:137, word:"قیمت",        translation:"price" },
  { id:138, word:"ارزان",       translation:"cheap" },
  { id:139, word:"گران",        translation:"expensive" },
  { id:140, word:"دانش‌آموز",   translation:"student" },
  { id:141, word:"دست",         translation:"hand" },
  { id:142, word:"پا",          translation:"foot/leg" },
  { id:143, word:"سر",          translation:"head" },
  { id:144, word:"چشم",         translation:"eye" },
  { id:145, word:"گوش",         translation:"ear" },
  { id:146, word:"دهان",        translation:"mouth" },
  { id:147, word:"قلب",         translation:"heart" },
  { id:148, word:"مغز",         translation:"brain" },
  { id:149, word:"خون",         translation:"blood" },
  { id:150, word:"درد",         translation:"pain" },
  { id:151, word:"سردرد",       translation:"headache" },
  { id:152, word:"تب",          translation:"fever" },
  { id:153, word:"باد",         translation:"wind" },
  { id:154, word:"ابر",         translation:"cloud" },
  { id:155, word:"آتش",         translation:"fire" },
  { id:156, word:"زمین",        translation:"earth/ground" },
  { id:157, word:"هوا",         translation:"air/weather" },
  { id:158, word:"روشنایی",     translation:"light" },
  { id:159, word:"تاریکی",      translation:"darkness" },
  { id:160, word:"گل",          translation:"flower" },
  { id:161, word:"عشق",         translation:"love" },
  { id:162, word:"خوشحالی",     translation:"happiness" },
  { id:163, word:"غم",          translation:"sadness" },
  { id:164, word:"ترس",         translation:"fear" },
  { id:165, word:"امید",        translation:"hope" },
  { id:166, word:"آزادی",       translation:"freedom" },
  { id:167, word:"صلح",         translation:"peace" },
  { id:168, word:"جنگ",         translation:"war" },
  { id:169, word:"آینده",       translation:"future" },
  { id:170, word:"گذشته",       translation:"past" },
  { id:171, word:"زندگی",       translation:"life" },
  { id:172, word:"مرگ",         translation:"death" },
  { id:173, word:"دنیا",        translation:"world" },
  { id:174, word:"راستی",       translation:"truth" },
  { id:175, word:"دروغ",        translation:"lie" },
  { id:176, word:"عقل",         translation:"reason/mind" },
  { id:177, word:"روح",         translation:"soul/spirit" },
  { id:178, word:"آرزو",        translation:"wish/dream" },
  { id:179, word:"خدا",         translation:"God" },
  { id:180, word:"حال",         translation:"present/now" },
  { id:181, word:"ایران",       translation:"Iran" },
  { id:182, word:"تهران",       translation:"Tehran" },
  { id:183, word:"اصفهان",      translation:"Isfahan" },
  { id:184, word:"شیراز",       translation:"Shiraz" },
  { id:185, word:"مشهد",        translation:"Mashhad" },
  { id:186, word:"پرنده",       translation:"bird" },
  { id:187, word:"ماهی",        translation:"fish" },
  { id:188, word:"اسب",         translation:"horse" },
  { id:189, word:"ظهر",         translation:"noon" },
  { id:190, word:"نمک",         translation:"salt" },
  { id:191, word:"سبزی",        translation:"vegetable" },
  { id:192, word:"مرغ",         translation:"chicken" },
  { id:193, word:"کشتی",        translation:"ship" },
  { id:194, word:"مهندس",       translation:"engineer" },
  { id:195, word:"راننده",      translation:"driver" },
  { id:196, word:"روستا",       translation:"village" },
  { id:197, word:"مسجد",        translation:"mosque" },
  { id:198, word:"نقاشی",       translation:"art/drawing" },
  { id:199, word:"استخوان",     translation:"bone" },
  { id:200, word:"آرزو",        translation:"desire/longing" },
];

export const MISSIONS = [
  { id:1,  title:"First Steps",       subtitle:"Greetings & essentials",    icon:"tulip", emoji:"🌱", color:"#22c55e", wordIds: VOCAB.filter(v=>v.id<=20).map(v=>v.id) },
  { id:2,  title:"Family & People",   subtitle:"People around you",         icon:"hand",  emoji:"👨‍👩‍👧", color:"#3b82f6", wordIds: VOCAB.filter(v=>v.id>20&&v.id<=40).map(v=>v.id) },
  { id:3,  title:"Numbers & Colors",  subtitle:"Count and describe",        icon:"pom",   emoji:"🎨", color:"#a855f7", wordIds: VOCAB.filter(v=>v.id>40&&v.id<=60).map(v=>v.id) },
  { id:4,  title:"Daily Life",        subtitle:"Time, places, objects",     icon:"arch",  emoji:"🏙️", color:"#f59e0b", wordIds: VOCAB.filter(v=>v.id>60&&v.id<=80).map(v=>v.id) },
  { id:5,  title:"Action Verbs",      subtitle:"What people do",            icon:"tulip", emoji:"⚡", color:"#ef4444", wordIds: VOCAB.filter(v=>v.id>80&&v.id<=100).map(v=>v.id) },
  { id:6,  title:"Travel & Places",   subtitle:"Getting around",            icon:"arch",  emoji:"✈️", color:"#06b6d4", wordIds: VOCAB.filter(v=>v.id>100&&v.id<=120).map(v=>v.id) },
  { id:7,  title:"Advanced Vocab",    subtitle:"Richer expressions",        icon:"hand",  emoji:"📚", color:"#8b5cf6", wordIds: VOCAB.filter(v=>v.id>120&&v.id<=140).map(v=>v.id) },
  { id:8,  title:"Body & Health",     subtitle:"Human body & wellbeing",    icon:"pom",   emoji:"🏥", color:"#10b981", wordIds: VOCAB.filter(v=>v.id>140&&v.id<=160).map(v=>v.id) },
  { id:9,  title:"Feelings",          subtitle:"Emotions & abstract ideas", icon:"tulip", emoji:"💜", color:"#ec4899", wordIds: VOCAB.filter(v=>v.id>160&&v.id<=180).map(v=>v.id) },
  { id:10, title:"Master Level",      subtitle:"Iran, culture & beyond",    icon:"arch",  emoji:"🏆", color:"#f59e0b", wordIds: VOCAB.filter(v=>v.id>180).map(v=>v.id) },
];

export function getMissionStatus(mission, wordStates, missionIdx) {
  if (missionIdx === 0) return "unlocked";
  const prev = MISSIONS[missionIdx - 1];
  const allDone = prev.wordIds.every((id) => wordStates[id]?.lastReviewTime > 0);
  return allDone ? "unlocked" : "locked";
}

// Level = number of fully completed missions + 1, capped at 10
export function getMissionLevel(wordStates) {
  const completed = MISSIONS.filter(m =>
    m.wordIds.every(id => wordStates[id]?.lastReviewTime > 0)
  ).length;
  return Math.min(completed + 1, 10);
}

export function getMissionProgress(mission, wordStates) {
  const words = mission.wordIds.map((id) => wordStates[id]).filter(Boolean);
  const reviewed = words.filter((w) => w && w.lastReviewTime > 0).length;
  return {
    total: mission.wordIds.length,
    reviewed,
    pct: Math.round((reviewed / mission.wordIds.length) * 100),
  };
}
